function normalizeOrigin(url) {
    if (!url) {
        return '';
    }

    return String(url).replace(/\/+$/, '');
}

/**
 * Risolve l'origin qlive (dev-qlive / qlive) in base a env o al backend qcenter.
 */
export function resolveQliveOrigin(options = {}) {
    if (options.qliveUrl) {
        return normalizeOrigin(options.qliveUrl);
    }

    const envUrl = process.env.REACT_APP_QLIVE_URL || (typeof window !== 'undefined' ? window._env_?.REACT_APP_QLIVE_URL : '');
    if (envUrl) {
        return normalizeOrigin(envUrl);
    }

    const backend = normalizeOrigin(options.qcenterBaseUrl || '');

    if (backend.includes('dev-qweb') || backend.includes('dev.qweb')) {
        return 'https://dev-qlive.hightek.it';
    }

    if (typeof window !== 'undefined') {
        const host = window.location.hostname;

        if (host.includes('dev-qlive') || host.includes('dev.qlive')) {
            return window.location.origin;
        }

        if (host.includes('qlive')) {
            return window.location.origin;
        }

        if (host.includes('dev-qweb') || host.includes('dev.qweb')) {
            return 'https://dev-qlive.hightek.it';
        }

        if (host.includes('qweb.hightek.it') && !host.includes('dev')) {
            return 'https://qlive.hightek.it';
        }
    }

    if (backend.includes('dev-')) {
        return 'https://dev-qlive.hightek.it';
    }

    return 'https://qlive.hightek.it';
}

export function isCurrentQliveOrigin(qliveOrigin) {
    if (typeof window === 'undefined' || !qliveOrigin) {
        return false;
    }

    return window.location.origin === qliveOrigin;
}
